<template>
    <div>
        <h4>{{inputmsg}}</h4>
        <input type="text" v-model="inputmsg"/>
        <p><span v-text="textdata"></span></p>
        <p v-html="str2"></p>
        <p><span v-pre>{{textdata}}是变量</span>{{textdata}}</p>
        <p><button v-on:click="show">按钮1</button></p>
        <!--多事件绑定,逗号分隔,执行先后取决于定义方法先后-->
        <p><button v-on:click="show(),show2()">按钮2</button></p>
        <p><button v-on:click="[show(),show2()]">多事件绑定2</button></p>
        <p><button @click="show">按钮3</button></p>
        <p><button @mousedown="mousdo" @click="show">不同类型事件1</button></p>
        <p><button v-on="{click:show,mousedown:mousdo}">不同类型事件2</button></p>
        <hr/>
        <h4>{{msg}}</h4>
        <p><button v-on:click="setmsg">修改msg</button></p>
        <hr/>
        <p><button v-on:click="showit('bt1')">btn1</button></p>
        <p><button v-on:click="showit('bt2')">btn2</button></p>
        <p><button v-on:click="showit('bt3')">btn3</button></p>
        <!--
          vue 特殊之处 方法传递参数可以直接使用仓库变量
          Vue 
        -->
        <p><button v-on:click="showit2(inputmsg)">btn4</button></p>
        <p><button v-on:click="showit3(this)">btn4-特列</button></p>
        <!--
           vue 中js原生对象需要加$
        -->
        <p><button v-on:click="showit4($event)">btn4-特列2</button></p>
        <p><button v-on:click.once="showit5()">一次性事件</button></p>
        <p><a href="www.baidu.com" @click.prevent>去百度-阻止跳转</a></p>
        <!--
          vue 事件修饰符
           stop阻止事件捕获与事件冒泡
           capture 事件捕获先父类后子类
           self 元素本上调用            
              
        -->
        <p>事件的冒泡与捕获</p>
        <div @click="divfun">
             <div @click.stop="divfunc">点我</div>
        </div>
        <div @click.capture="divfun">
             <div @click="divfunc">点我2</div>
        </div>
        <hr/>
        <div>
           <!--
             捕获事件的应用
           --> 
           <ul @click.capture="printfun($event)">
             <li>uli01</li>
             <li>uli02</li>
             <li>uli03</li>
             <li>uli04</li>
           </ul> 
        </div>
        <p v-show="true">我是p标签</p>
        <p v-show="myflage">我是pp标签</p>
        <p v-show="myflage2">我是pp标签-隐藏</p>
        <button @click="showll">pp标签切换</button>

        <p v-if="myflage">我是if pp标签</p>
        <p v-if="myflage2">我是if pp标签222</p>
        <hr/>
        <ul>
          <li v-for="item in items" :key="item.name">{{item.name}}{{item.age}}</li>
        </ul>
        <ul>
          <li v-for="item in 5" :key="item">{{item}}</li>
        </ul>
        <hr/>
        <p v-bind:id="'pid'" v-bind:name="pname">v-bind写法</p>
        <p v-bind="{id:'pid',name:'pt2name',data:'pdate'}">v-bind-多属性写法2</p>
        <p>
          <input type="text" placeholder="请填写" v-bind:disabled="myflage"/>
        </p>
        <p class="fc bc">普通classp</p>
        <p :class="pnamec">普通bind 变量class</p>
        <p :class="['fc','bc']">普通bind 数组class</p>
        <p :class="pnamecc">普通bind 数组--变量class</p>
        <p :class="pnameccobj">普通bind 数组--变量对象class</p>
        <button @click="cremove('fc')">删除class fc</button>
        <button @click="cremoveadd('fc')">添加class fc</button>
         <!--style绑定字符串用于静态-->
         <p :style="stystr">我是P标签</p>
         <!--style绑定对象用于动态控制-->
         <p :style="stystrobj">我是P标签</p>
         <button @click="cremoveadd2()">删除颜色</button>
          <p :class="'fc bc'">我是P标签</p>
          <!--v-bind prop修饰符强制转换dom属性
              注意连字符写法
          -->
          <p :class-name.prop="'fc bc'">我是P标签</p>
          <!--v-bind prop修饰符强制转换dom属性
              camel 强制使用驼峰法
              注意prop与camel前后顺序
          -->
          <p :className.camel.prop="'fc bc'">我是P标签</p>
          <p>双向数据绑定</p>
          <hr/>
          <h4>{{inputmsg}}</h4>
          <input type="text" v-model="inputmsg"/>
          <hr/>
          <input type="checkbox" true-value="同意" false-value="取消" vv-model="info"/>
          <br/>
          <input type="checkbox" true-value="同意" false-value="取消" vv-model="info2"/>
          <hr/>
          <h4>{{inputmsg}}</h4>
          <!--
            v-model.lazy 把input事件用change事件
          -->
          <input type="text" v-model.lazy="inputmsg"/>
          <!--
            v-model.number 把能转换数值的进行转换,不能的原样记录
          -->
          <input type="text" v-model.number="inputmsg"/>
          <!--
            v-model.trim 移除输入首空格
          -->
          <input type="text" v-model.trim="inputmsg"/>


    </div>
</template>
<script>
import { Indicator, Toast } from 'mint-ui'
export default {
    name:'tindex',
    data(){
       return{
         info:'',
         info2:'同意',
         msg:'旧的值',
         inputmsg:'mydef',
         textdata:'hello',
         str2:"<h1>666</h1>",
         myflage:true,
         myflage2:false,
         items:[{name:'张三',age:10},{name:'李四',age:15},{name:'王五',age:20}],
         pname:'ptname',
         pnamec:"fc bc",
         pnamecc:['fc','bc'],
         pnameccobj:{fc:false,bc:true},
         stystr:"color:red",
         stystrobj:{color:'red','font-size':'20px',}
       } 
    },
    methods:{
        cremoveadd2(){
          this.stystrobj.color="";
        },
        //es6写法
        cremoveadd(agv){
          this.pnamecc.push(agv);
        },
        cremove(agv){
          this.pnamecc.shift(agv);
        },
        show(){
            console.log("vue-->btn1");
        },
        show2(){
            console.log("vue-->btn1-->go");
        },
        mousdo(){
            console.log("vue--btn--mousedown");
        },
        setmsg(){
            console.log(this);
            console.log(this.msg);
            this.msg="6666";
        },
        showit(t){
            console.log(t+"-->click");
        },
         showit2(t){
            console.log(t);
        },
         showit3(t){
            console.log(t);
        },
        showit4(t){
            console.log(t);
        },
        showit5(){
            console.log("一次事件");
        },
        divfun(){
           console.log("点击 父div"); 
        },
        divfunc(){
           console.log("点击 子div"); 
        },
        printfun(e){
            console.log(e.target.innerHTML);
        },
        showll(){
           if(this.myflage==true){
              this.myflage=false;
           }
           else{
              this.myflage=true;
           }
        }
    },
    watch: {
       // 监听用户列表变化，更新全选状态
       info2: {
           handler() {
               console.log(this.info2);
           },
           deep: true
       }
   }
}
</script>
<style scoped lang='scss'>
  li{
    padding-bottom:10px;
    border-bottom:1px solid #ccc;
  }
  .fc{
    color:red;
  }
  .bc{
    font-weight: bold;
  }
</style>